// Cleans post HTML before it is rendered with v-html. Bodies are also sanitized by the
// Messages service on write (PostBodySanitizer); this is the second line of defence for
// posts saved before that change. The allow-list matches the TipTap editor
// (components/editor/RichTextEditor.vue).

const ALLOWED_TAGS = new Set([
  'P', 'BR', 'H1', 'H2', 'H3', 'STRONG', 'B', 'EM', 'I', 'U', 'S',
  'UL', 'OL', 'LI', 'BLOCKQUOTE', 'CODE', 'PRE', 'HR', 'A', 'IMG',
]);

const ALLOWED_ATTRIBUTES = new Set(['href', 'src', 'alt', 'title', 'style']);
const SAFE_URL = /^(https?:|mailto:|tel:)/i;
const SAFE_STYLE = /^\s*text-align\s*:\s*(left|right|center|justify)\s*;?\s*$/i;

function cleanNode(node) {
  Array.from(node.childNodes).forEach((child) => {
    if (child.nodeType === Node.TEXT_NODE) {
      return;
    }

    if (child.nodeType !== Node.ELEMENT_NODE) {
      child.remove();
      return;
    }

    if (!ALLOWED_TAGS.has(child.tagName)) {
      // Keep the text of unknown tags, drop the tag itself. Script-like content is removed whole.
      if (['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'TEMPLATE'].includes(child.tagName)) {
        child.remove();
        return;
      }

      cleanNode(child);
      child.replaceWith(...Array.from(child.childNodes));
      return;
    }

    Array.from(child.attributes).forEach((attribute) => {
      const name = attribute.name.toLowerCase();
      const { value } = attribute;

      const allowed = ALLOWED_ATTRIBUTES.has(name)
        && (!['href', 'src'].includes(name) || SAFE_URL.test(value.trim()))
        && (name !== 'style' || SAFE_STYLE.test(value));

      if (!allowed) {
        child.removeAttribute(attribute.name);
      }
    });

    if (child.tagName === 'A') {
      child.setAttribute('target', '_blank');
      child.setAttribute('rel', 'noopener noreferrer');
    }

    cleanNode(child);
  });
}

export default function sanitizeHtml(html) {
  if (!html) {
    return '';
  }

  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
  const root = doc.body.firstChild;

  if (!root) {
    return '';
  }

  cleanNode(root);
  return root.innerHTML;
}
